import { request } from './auth-actions'
import { genericError } from './action-utils'
import {
  STATISTICS_GET_CHART,
  STATISTICS_GET_TOPLIST,
  STATISTICS_GET_TREND,
  STATISTICS_GET_STATUS,
} from './action-types'
import statsApi from '../../api/payment-engine-stats-api'
import { prepareForChart } from '../../util/compatibilityBridge'

export const getChartSuccess = (raw, data, target) => ({
  type: STATISTICS_GET_CHART,
  data,
  raw,
  target,
})

const statisticsEndpoints = {
  gender: statsApi.getGender,
  channels: statsApi.getSalesByChannel,
  returning: statsApi.getSalesType,
  paymentmethods: statsApi.getSalesByPaymentMethods,
}

export const getChart = query => dispatch => {
  if (statisticsEndpoints[query.target]) {
    return dispatch(request(statisticsEndpoints[query.target], query))
      .then(response => {
        dispatch(
          getChartSuccess(
            response.data,
            prepareForChart(response.data),
            query.target,
          ),
        )
      })
      .catch(error => {
        genericError(error)
        throw error
      })
  }
  return dispatch({ type: 'UNKNOWN_CHART_TARGET', value: query.target })
}

export const getTopSuccess = response => ({
  type: STATISTICS_GET_TOPLIST,
  response: { list: response.content },
  target: 'toplist',
})

export const getTop = query => dispatch => {
  return dispatch(request(statsApi.getTopSellers, query))
    .then(data => {
      dispatch(getTopSuccess(data))
    })
    .catch(error => {
      genericError(error)
      throw error
    })
}

export const getTrendSuccess = response => ({
  type: STATISTICS_GET_TREND,
  response: { trend: response },
  target: 'toplist',
})

export const getTrend = query => dispatch => {
  return dispatch(request(statsApi.getTrend, query))
    .then(data => {
      dispatch(getTrendSuccess(prepareForChart(data.data)))
    })
    .catch(error => {
      genericError(error)
      throw error
    })
}

export const getStatusSuccess = response => ({
  type: STATISTICS_GET_STATUS,
  response,
})

export const getStatus = query => dispatch => {
  return dispatch(request(statsApi.getSalesPersonAmountStats, query))
    .then(data => {
      dispatch(getStatusSuccess({ data }))
    })
    .catch(error => {
      genericError(error)
      throw error
    })
}
